<!-- src/components/Loader.vue -->
<template>
  <div
    class="d-flex justify-content-center align-items-center fullscreen-loader"
    style="height: 100%"
  >
    <div class="d-flex justify-content-center align-items-center vh-100">
      <div
        class="card p-0 text-center shadow"
        style="width: 25rem; border-radius: 6px"
      >
        <div class="card-body">
          <div class="dot-loader mb-2 mt-3">
            <span></span><span></span><span></span><span></span>
          </div>
          <h5>This may take a moment. Please Wait !!!</h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoaderPage",
};
</script>

<style scoped>
.fullscreen-loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(94, 93, 93, 0.767);
  z-index: 1050;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dot-loader {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
}

.dot-loader span {
  width: 10px;
  height: 10px;
  background-color: orange;
  border-radius: 50%;
  animation: bounce 0.6s infinite alternate;
}

.dot-loader span:nth-child(2) {
  animation-delay: 0.2s;
}
.dot-loader span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes bounce {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-10px);
  }
}
</style>
